import Icon from "./IconBase.js";
const VideoIcon = (props) => {
  return (
    <Icon
      width="18"
      height="18"
      viewBox="0 0 18 18"
      style={{ borderColor: "white" }}
      {...props}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 14 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 6.5C1 3.19165 3.77964 0.5 7.19672 0.5C10.6138 0.5 13.3934 3.19165 13.3934 6.5C13.3934 9.80833 10.6138 12.5 7.19672 12.5C3.77964 12.5 1 9.80833 1 6.5ZM1.5165 6.49999C1.5165 9.53273 4.06469 12 7.19684 12C10.329 12 12.8772 9.53273 12.8772 6.49999C12.8772 3.46727 10.329 0.999988 7.19684 0.999988C4.06469 0.999988 1.5165 3.46727 1.5165 6.49999Z"
          fill="#757575"
        />
        <path
          d="M7.19672 0.4C3.72748 0.4 0.9 3.13341 0.9 6.5H1.1C1.1 3.2499 3.83181 0.6 7.19672 0.6V0.4ZM13.4934 6.5C13.4934 3.13341 10.666 0.4 7.19672 0.4V0.6C10.5616 0.6 13.2934 3.2499 13.2934 6.5H13.4934ZM7.19672 12.6C10.666 12.6 13.4934 9.86658 13.4934 6.5H13.2934C13.2934 9.75009 10.5616 12.4 7.19672 12.4V12.6ZM0.9 6.5C0.9 9.86658 3.72748 12.6 7.19672 12.6V12.4C3.83181 12.4 1.1 9.75009 1.1 6.5H0.9ZM7.19684 11.9C4.11685 11.9 1.6165 9.47448 1.6165 6.49999H1.4165C1.4165 9.59097 4.01252 12.1 7.19684 12.1V11.9ZM12.7772 6.49999C12.7772 9.47448 10.2768 11.9 7.19684 11.9V12.1C10.3812 12.1 12.9772 9.59097 12.9772 6.49999H12.7772ZM7.19684 1.09999C10.2768 1.09999 12.7772 3.52552 12.7772 6.49999H12.9772C12.9772 3.40903 10.3812 0.899988 7.19684 0.899988V1.09999ZM1.6165 6.49999C1.6165 3.52552 4.11685 1.09999 7.19684 1.09999V0.899988C4.01252 0.899988 1.4165 3.40903 1.4165 6.49999H1.6165Z"
          fill="#757575"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.91769 3.77064L9.93406 6.27327C10.0159 6.32435 10.0658 6.41259 10.0658 6.50712C10.0658 6.60159 10.0159 6.68985 9.93406 6.74092L5.91769 9.24352C5.87063 9.27312 5.81627 9.28779 5.76248 9.28779C5.71541 9.28779 5.66778 9.27639 5.6252 9.25385C5.53274 9.20499 5.47559 9.11152 5.47559 9.00972V4.00445C5.47559 3.90263 5.53274 3.80919 5.6252 3.76031C5.71598 3.71198 5.82972 3.71498 5.91769 3.77064ZM6.04927 4.51388V8.50024L9.24814 6.50711L6.04927 4.51388Z"
          fill="#757575"
        />
      </svg>
    </Icon>
  );
};
export default VideoIcon;
